import React from "react";

export const ComponentMap = {
  "react-navigation": React.createElement(
    React.lazy(
      () => import("./components/organisms/navigation/navigation.jsx"),
    ),
  ),
  "react-richtext-component": React.createElement(
    React.lazy(() => import("./components/molecules/richtextComponent.jsx")),
  ),
  "react-vimeo-player-component": React.createElement(
    React.lazy(() => import("./components/molecules/vimeoPlayerComponent.jsx")),
  ),
  "react-accordion-component": React.createElement(
    React.lazy(() => import("./components/molecules/accordionComponent.jsx")),
  ),
  "react-conversation-starter-component": React.createElement(
    React.lazy(
      () => import("./components/molecules/conversationstarterComponent.jsx"),
    ),
  ),
  "react-article-ribbon-component": React.createElement(
    React.lazy(
      () => import("./components/molecules/articleRibbonComponent.jsx"),
    ),
  ),
  "react-questionaire-component": React.createElement(
    React.lazy(
      () =>
        import("./components/molecules/questionaire/questionaireComponent.jsx"),
    ),
  ),
  "react-article-overview-component": React.createElement(
    React.lazy(
      () =>
        import("./components/molecules/articleOverview/articleOverview.jsx"),
    ),
  ),
  "react-quiz-component": React.createElement(
    React.lazy(() => import("./components/molecules/quizComponent.jsx")),
  ),
  "react-quote-slider-component": React.createElement(
    React.lazy(() => import("./components/molecules/quoteSliderComponent.jsx")),
  ),
  "react-side-panel-component": React.createElement(
    React.lazy(() => import("./components/molecules/sidePanelComponent.jsx")),
  ),
  "react-instagram-feed-component": React.createElement(
    React.lazy(
      () => import("./components/molecules/instagramFeedComponent.jsx"),
    ),
  ),
  "react-search": React.createElement(
    React.lazy(() => import("./components/organisms/search/search.jsx")),
  ),
  "react-search-results": React.createElement(
    React.lazy(() => import("./components/organisms/search/searchResults.jsx")),
  ),
  "react-vimeo-frontendplayer-component": React.createElement(
    React.lazy(
      () => import("./components/molecules/vimeoPlayerFrontpageComponent.jsx"),
    ),
  ),
  // ...
};

export default ComponentMap;
